
 <!-- <ng-template [ngIf]="nextLoaded" [ngIfElse]="nextLoading"> -->
<div class="table-responsive" >
  <table mat-table [dataSource]="dataSource">

    
    <!-- Date Column -->
    <ng-container matColumnDef="datefa">
      <th mat-header-cell *matHeaderCellDef> {{ 'PAYMENT.FACTURATION.TABLE1' | translate }} </th>
      <td mat-cell *matCellDef="let element"> {{element.date | date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <!-- Motif Column -->
    <ng-container matColumnDef="motif">
      <th mat-header-cell *matHeaderCellDef> {{ 'PAYMENT.FACTURATION.TABLE2' | translate }} </th>
      <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
    </ng-container>

    <!-- Tarif Column -->
    <ng-container matColumnDef="tarif">
      <th mat-header-cell *matHeaderCellDef> <b>{{ 'PAYMENT.FACTURATION.TABLE3' | translate }}</b> </th>
      <td mat-cell *matCellDef="let element">{{element.amount}} €</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>
<!-- </ng-template>
<ng-template #nextLoading>
  <mat-spinner style="margin: auto;"></mat-spinner>
</ng-template> -->

